import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import ArticleIcon from '@mui/icons-material/Article';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import PersonIcon from '@mui/icons-material/Person';

import * as ROUTES from '../../helpers/routes';
import ItemDialog from '../List/ItemDialog';
import { useItem } from '../../contexts/Item';
import { useAuth } from '../../contexts/Authentication';

const BottomButtons = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authenticating, user } = useAuth();
  const { openDialog } = useItem();

  const [value, setValue] = useState(location);

  useEffect(() => {
    setValue(location);
  }, [location]);

  const onClick = (destination) => {
    if (destination === ROUTES.ADD) {
      openDialog();
    } else {
      navigate(destination);
    }
  };

  if (!authenticating && !user) {
    return null;
  }

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={5}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => onClick(newValue)}
      >
        <BottomNavigationAction label="My Person" value={ROUTES.PERSON} icon={<PersonIcon />} />
        <BottomNavigationAction label="Add Item" value={ROUTES.ADD} icon={<AddIcon />} />
        <BottomNavigationAction label="My List" value={ROUTES.LIST} icon={<ArticleIcon />} />
      </BottomNavigation>
      <ItemDialog />
    </Paper>
  )
}

export default BottomButtons;